export default function HeaderBox({
  children,
}: {
  children: JSX.Element[] | JSX.Element;
}): JSX.Element {
  return <div className="header-box">{children}</div>;
}
